module.exports = __webpack_public_path__ + "static/media/curlegance-3.12851ec7.jpg";